import React, { useEffect, useContext, useState } from "react";
import { Route, withRouter, useHistory } from "react-router-dom";
import $ from "jquery";
import AOS from "aos";

import PsContext from "../../context";
import Footer from "./footer/footer";
import FooterBottom from "./footer/footerBottom";
import HeaderLogo from "./header/headerLogo";
// import Slider from "./sliderstatic/slider"
import TopHeader from "./header/topHeader";
import TopMenu from "./header/topMenu";

import Routes from "../index";
import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import SideBar from "./sideBar";
import { SuperSEO } from "react-super-seo";
import FooterButton from "./footer/footerButton";
import SettingsOffCanvas from "./settingsOffCanvas";
import VideoPage from "./VideoPage";
import { _HOME_PAGE_SETTINGS } from "../../models/fieldSettings";
import { lowerCase } from "../../utils";

const DefaultLayout = (props) => {
  const context = useContext(PsContext);
  const history = useHistory();
  const [homePageSettings, setHomePageSettings] = useState([]);

  useEffect(() => {
    _HOME_PAGE_SETTINGS().then((res) => {
      if (res.status == "1") {
        setHomePageSettings(res.data);
      } else {
        console.log("Error on loading home page settings..");
      }
    });
  }, []);

  const checkComponentActive = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    return m && m.show_on_site == "1" ? true : false;
  };

  const componentContent = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    if (m && m.show_on_site == "1") {
      if (m && m.component_filter) {
        let jv = m.component_filter;
        if (jv && jv.length > 3) {
          let x = JSON.parse(jv.trim());
          return x;
        }
      }
    }
    return [];
  };
  useEffect(() => {
    context.loadSettings();
  }, []);

  useEffect(() => {
    AOS.init({
      //offset: 200,
      //duration: 600,
      easing: "ease-in-sine",
      delay: 200,
    });

    $("html, body").animate({ scrollTop: 0 });
  }, [props.match.path, props.match.params]);

  const themeStyles = `
    .ps__top__menu{
      background-color:${context.settingValue(
        "web_site_header_bgcolor"
      )} !important;    
    }
  `;

  return (
    <>
      <SuperSEO title={context.settingValue("web_site_meta_title")} lang="en" />
      <style>{themeStyles}</style>

      {context.windowSize >= 1360 &&
        (history.location.pathname == "" ||
          history.location.pathname == "/") && (
          <VideoPage dataSource={componentContent("home_video_slider")} />
        )}

      {/* {checkComponentActive("home_video_slider") && (
        <>
          {context.windowSize >= 1360 &&
            (history.location.pathname == "" ||
              history.location.pathname == "/") && (
              <VideoPage dataSource={componentContent("home_video_slider")} />
            )}
        </>
      )} */}

      {/* <TopHeader /> */}
      <HeaderLogo />

      <TopMenu />

      {/*Routes.defaultlayout.map((item) => (
        <Route path={item.path} component={item.component} exact={item.exact} />
      ))*/}
      <Switch>
        {Routes.defaultlayout.map((item, i) => {
          return (
            <Route
              path={item.path}
              component={item.component}
              exact={item.exact}
            />
          );
        })}
      </Switch>

      <SettingsOffCanvas />

      <Footer />
      <FooterButton />
      <FooterBottom />
    </>
  );
};

export default withRouter(DefaultLayout);
